import React from 'react';
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { Link } from "react-router-dom";

function preprocess(content: string) {

    // For enabling custom span styling
    // Relies on syntax: {{class names|content between span, including [markdown](/link)}} 

    return content.replace(
        /\{\{(.+?)\|(.+?)\}\}/g,
        (_, className, inner) => `<span class="${className}">${inner}</span>`
    );
}

export function parseUpdateParagraph(content: string, key: string, tailwind: string = "paragraph", styling: React.CSSProperties = {}) {
  return (
    <div key={key} className={tailwind} style={styling}>
        <Markdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={{
                a: ({ href, children }) => ( <span><Link to={href || "/"}>{ children }</Link></span> ),
                strong: ({ children }) => ( <strong className="font-extra-bold">{ children }</strong> ),
                em: ({ children }) => ( <em className="italic">{ children }</em> ),
                p: ({ children }) => <p>{children}</p>,
            }}
        >
            {preprocess(content)}
        </Markdown>
    </div>
  );
}